import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const OrderSuccess = () => {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    loadOrder();
  }, [orderId]);

  const loadOrder = async () => {
    try {
      const response = await axios.get(`${API}/orders/${orderId}`);
      setOrder(response.data);
    } catch (error) {
      console.error('Error loading order:', error);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center" data-testid="order-success-page">
      <div className="max-w-2xl mx-auto px-4 text-center">
        <CheckCircle className="w-24 h-24 text-[#10B981] mx-auto mb-6" data-testid="success-icon" />
        <h1 className="heading-font text-5xl font-black uppercase mb-4" data-testid="success-title">
          ORDER <span className="text-[#D4AF37]">CONFIRMED!</span>
        </h1>
        <p className="text-xl text-[#A1A1AA] mb-8">
          Thank you for your order. We'll send you a confirmation email shortly.
        </p>
        
        {order && (
          <div className="glass p-8 mb-8 text-left" data-testid="order-details">
            <h2 className="heading-font text-2xl font-bold uppercase mb-4">Order Details</h2>
            <div className="space-y-2">
              <p><span className="text-[#A1A1AA]">Order Number:</span> <span className="font-bold" data-testid="order-number">{order.order_number}</span></p>
              <p><span className="text-[#A1A1AA]">Customer Name:</span> <span className="font-bold">{order.customer_name}</span></p>
              <p><span className="text-[#A1A1AA]">Total Amount:</span> <span className="font-bold text-[#D4AF37]" data-testid="order-total">₹{order.total_amount}</span></p>
              <p><span className="text-[#A1A1AA]">Payment Method:</span> <span className="font-bold uppercase">Online Payment (Razorpay)</span></p>
            </div>
          </div>
        )}

        <div className="space-y-4">
          <Link to="/products">
            <button className="btn-gold px-8 py-3 w-full sm:w-auto" data-testid="continue-shopping-button">
              CONTINUE SHOPPING
            </button>
          </Link>
          <p className="text-sm text-[#A1A1AA]">
            Need help? Contact us on WhatsApp: <a href="https://wa.me/919328566392" className="text-[#D4AF37] hover:underline">+91 93285 66392</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default OrderSuccess;